<script>
import moment from 'moment'
import config from '../../config'
let wikiUrl = config.wikiUrl
export default {
  name: 'CommonMixin',
  computed: {},
  methods: {
    alertException (err) {
      console.log(`Error: ${err.message}`)
      let msg = 'Something wrong.Try again later'
      if (err.response) {
        const data = err.response.data
        if (data && data.msg) {
          if (typeof data.msg === 'string') {
            msg = data.msg
          }
          if (Array.isArray(data.msg)) {
            msg = data.msg[0]
          }
        }
      }
      this.alertError(msg)
    },
    alertError (msg, title) {
      this.$store.commit('setAlertMessage', { type: 'error', title: title || 'Error', open: true, msg: msg })
    },
    alertSuccess (msg, title) {
      this.$store.commit('setAlertMessage', {
        type: 'success',
        title: title || 'Success',
        open: true,
        msg: msg
      })
    },
    showLoading (status) {
      this.$store.commit('setShowLoadingScreen', status)
    },
    getLinkWiki (url) {
      return wikiUrl + '/' + url
    },
    formatFullTime12Hour (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return moment(time).format('MM/DD/YYYY hh:mm A')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatTimeWithHour (time) {
      let time2 = time
      if (typeof time2 !== 'undefined' && time2 !== 'undefined' && time2 !== null) {
        if (moment(time).isValid()) {
          return moment(time2).format('hh:mm A')
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatTime (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return newTime
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatPhone (phone) {
      if (phone) {
        if (phone.length === 10) {
          return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
        } else {
          return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4')
        }
      }
      return ''
    },
    fileSize (bytes, decimals) {
      if (decimals === undefined) decimals = 1
      if (bytes === 0) return '0B'
      if (bytes < 0) return '--'
      let k = 1000, dm = decimals || 2, sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i]
    },
    fileIcon (mimeType) {
      // const clazz = ['nothumb', 'pdf', 'word', 'excel', 'ppt', 'odt', 'video', 'audio', 'zip', 'img']
      switch (mimeType) {
        case 'image/gif':
        case 'image/png':
        case 'image/jpeg':
          return 'img'
        case 'application/pdf':
          return 'pdf'
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'word'
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          return 'excel'
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          return 'ppt'
        case 'video/x-msvideo':
        case 'video/mpeg':
        case 'video/ogg':
        case 'video/webm':
        case 'video/3gpp':
        case 'video/3gpp2':
        case 'video/x-matroska':
        case 'video/x-flv':
        case 'video/x-ms-wmv':
        case 'video/mp4':
        case 'video/avi':
        case 'video/x-ms-asf':
        case 'video/quicktime':
          return 'video'
        case 'audio/mid':
        case 'audio/midi':
        case 'audio/ogg':
        case 'audio/wav':
        case 'audio/x-wav':
        case 'audio/webm':
        case 'audio/3gpp':
        case 'audio/3gpp2':
        case 'video/mp3':
        case 'audio/x-aiff':
        case 'audio/aiff':
        case 'audio/basic':
        case 'audio/vnd.dolby.dd-raw':
        case 'audio/x-flac':
        case 'audio/x-hx-aac-adts':
        case 'audio/vnd.dlna.adts':
        case 'audio/mpeg':
        case 'audio/x-ms-wma':
        case 'audio/x-matroska':
          return 'audio'
        case 'application/x-bzip':
        case 'application/x-bzip2':
        case 'application/zip':
        case 'application/x-7z-compressed':
        case 'application/x-rar-compressed':
        case 'application/x-tar':
        case 'application/x-rar':
          return 'zip'
        default:
          return 'nothumb'
      }
    },
    getLinkProfileAccount (id) {
      return `/encounter?patient=5b9ec0c93ed9dbc7dac2109b&accountId=${id}`
    }
  }
}
</script>
